import type {UserAddressPin} from '../api/address/model/types'

export function getAddressDetails(address: UserAddressPin) {
  return {
    floor: address.floor,
    entrance: address.entrance,
    code: address.code,
    apartment: address.apartment,
    comment: address.comment,
  }
}
